import { useAuth } from '@services/auth'
import { useGetCompanies } from '@services/companies'
import { ICompany } from '@services/companies/companies.type'
import React from 'react'

const useUserOrgSession = () => {
  const { user } = useAuth()
  const [isCompleted, setIsCompleted] = React.useState(false)
  const [orgSession, setOrgSession] = React.useState<ICompany | undefined>(
    undefined
  )
  const [isLoading, setIsLoading] = React.useState(true)

  const { byId: getCompanyById } = useGetCompanies()

  React.useEffect(() => {
    if (!user) {
      return
    }
    if (!user?.orgSessionId) {
      setOrgSession(undefined)
      setIsLoading(false)
      setIsCompleted(true)
      return
    }
    const orgSession = getCompanyById?.[user?.orgSessionId] as ICompany
    // 沒有上層表示無單位
    if (!orgSession?.parentSessionId) {
      setOrgSession(undefined)
      setIsLoading(false)
      setIsCompleted(true)
      return
    }
    setOrgSession(orgSession)
    setIsLoading(false)
    setIsCompleted(true)
  }, [getCompanyById, user])

  return { orgSession, isLoading, isCompleted }
}

export default useUserOrgSession
